module.exports = flarum.reg.get('flarum-tags', 'common/helpers/tagsLabel');